import { Model } from 'pinia-orm';
import { Str, Attr, Uid, Num, HasOne } from 'pinia-orm/decorators';
import { User } from 'src/modules/User/models/User';
import type { UserStepProgress } from 'types/course/step';
import type { Step } from './Step';
import type { ApiUserStepUserStep } from 'src/types/contentTypes';
import type { StrapiAttr } from 'src/types/strapi';

/** Scalar field types are derived from the backend schema — see src/types/strapi.ts. */
type UserStepAttr<K extends keyof ApiUserStepUserStep['attributes']> =
  StrapiAttr<ApiUserStepUserStep, K>;

export class UserStep extends Model {
  static override entity = 'user_steps';

  @Uid() declare id: number;
  @Str(null) declare documentId: string | null;

  // Strapi types these as DateTime (Date | string); over REST they always
  // arrive as ISO strings, so the narrower type is the accurate one.
  @Str(null) declare start_date: string | null;
  @Str(null) declare completion_date: string | null;
  @Num(null) declare user_section_id: UserStepAttr<'user_section_id'>;
  @Num(0) declare score: UserStepAttr<'score'>;
  @Num(0) declare time_accumulator: UserStepAttr<'time_accumulator'>;
  // Stored as JSON on the backend; the mutator below parses it into a shape
  // Strapi cannot describe, so this stays hand-typed.
  @Attr('{}') declare progress: UserStepProgress;
  @Attr(null) declare step: Step | null;
  @Num(null) declare step_id: number;

  @HasOne(() => User, 'user_id') declare user_id: User | null;

  static override mutators() {
    return {
      progress: {
        get: (value: string) => JSON.parse(value) as UserStepProgress,
        set: (value: UserStepProgress) => JSON.stringify(value),
      },
    };
  }
}
